import { Component, inject, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { map } from "rxjs/operators";
import { fromToolbar, ToolbarActions } from 'shared/classroom/toolbar/data-access';
import { ToolbarButtonComponent } from '../toolbar-button.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'pcp-slide-sync-toolbar-button-redo',
    templateUrl: './toolbar-button-redo.component.html',
    styleUrls: ['./toolbar-button-redo.component.scss'],
    imports: [ToolbarButtonComponent, AsyncPipe]
})
export class ToolbarButtonRedoComponent {
    private readonly store: Store = inject(Store);

    @Input() matIconName = 'redo';
    @Input() fontSet = '';

    readonly isDisabled$ = this.store.select(
        fromToolbar.isRedoButtonActivateable
    ).pipe(
        map(isActivateable => !isActivateable),
    );

    public forward() {
        this.store.dispatch(ToolbarActions.toolbarRedo());
    }
}

